import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import ActionLink from '../ActionLink';
import CustomDialog from '../CustomDialog';
import { TabView, TabPanel } from 'primereact/tabview';
import HlsPlayerCustomBar from '../HlsPlayerCustomBar';
import TransactionService from '../../services/TransactionService';
import AuthService from '../../services/AuthService';
import { t } from 'i18next';

export default function NotificationComponentProp({...props}) {
    const [notificationListVisible, setNotificationListVisible] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [transactionVideo, setTransactionVideo] = useState(undefined);
    const [tvDate, setTvDate] = useState(undefined);
    const [tvCardNo, setTvCardNo] = useState(undefined);
    const [tvData, setTvData] = useState(undefined);
    const [videos, setVideos] = useState(undefined);
    const [videoDuration, setVideoDuration] = useState(undefined);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(1);
     const transactionService = new TransactionService();
     const authService = new AuthService();

    const translate = (key, params) => {
        if (props.translations && props.translations[key]) {
            let translation = props.translations[key];
            if (params) {
                for (const param in params) {
                    translation = translation.replaceAll(`{{${param}}}`, params[param]);
                }
            }
            return translation;
        } else {
            return key;
        }
    };

    const showVideoDialog = (n) => {
        if (n.videoStatus === 'READY') {

            setTransactionVideo(undefined);
            setVideos(undefined);
            setVideoDuration(undefined);
            setTvDate(n.trxDate);
            setTvCardNo(n.cardNo);
            setTvData(n);
            fetchVideoData(n);
            setVideoDialogVisible(true);

            //setVideo({petraId: n.videoPetraId, videoHeight: n.videoHeight, videoWidth: n.videoWidth});
        }
    };

    const fetchVideoData = (n) => {
        transactionService.checkTransactionVideoStartStreaming({
            petraId: n.videoPetraId,
            cardNumber: n.cardNo,
            dateTime: n.trxDate,
        }).then((res) => {
            if (res.streamingStarted === true && res.alreadyPreparing) {
                // wideo gotowe – otwieramy dialog
                setVideos(res.videos);
                setVideoDuration(res.videoDuration);
                setTransactionVideo(res);
            }

        })
            .catch(() => {

                // this.showErrorMessage(t("transaction.videoRecord.error"));
            });
    };

    const reFetchVideoData = (n) => {
        transactionService.checkTransactionVideoStartStreaming({
            petraId: tvData?.videoPetraId,
            cardNumber: tvData?.cardNo,
            dateTime: tvData?.trxDate,
        }).catch((err) => {
            });
    };

    const clearNotifications = () => {
        if (props.websocket) {
            props.websocket.send(
                JSON.stringify({
                    operation: 'CLEAR',
                    token: props.token,
                })
            );
        }
    };

    const refreshCurrentTab = (data) => {
        setRefreshKey(Date.now());
        reFetchVideoData(data)
    };

    const  returnHlsPlayer = () => {

        return (
            <div className="hls-tabs-container-custom"> {/* <--- inna klasa */}
                <TabView
                    activeIndex={0}
                  //  onTabChange={props.handleTabChange}
                >
                    {videos?.map(v => {
                        const textHeader = t(`transaction.cameraPosition.${v.cameraPosition}`);
                        return (
                            <TabPanel header={textHeader}>
                                <div className="video-tabs-custom"> {/* <--- inna klasa */}
                                    <HlsPlayerCustomBar
                                        key={`${v.index}-${refreshKey}`}
                                        src={`${process.env.REACT_APP_BACKEND_URL}/transaction/${v.videoPath}?token=${authService.getToken()}`}
                                        controls
                                        videoStatus={transactionVideo?.status}
                                        totalDuration={videoDuration}
                                        onReady={() => this.unblockUi()}
                                        onRefresh={() => refreshCurrentTab(transactionVideo)}
                                    />
                                </div>
                            </TabPanel>
                        );
                    })}
                </TabView>
            </div>
        );
    }


    
    const markAsReadNotifications = () => {
        let notifications = notificationList?.filter(n => n.status === 'UNREAD');
        if(notifications?.length > 0){
            notifications.forEach((n) => {
                if (props.websocket) {
                    props.websocket.send(
                        JSON.stringify({
                            operation: 'MARK_AS_READ',
                            token: props.token,
                            entityUuid: n.entityUuid,
                        })
                    );
                }
    
              }
            )
        }
       
    };


    const updateNotificationList = useCallback(
        (m) => {
            const message = JSON.parse(m.data);
            if (message.operation) {
                switch (message.operation) {
                    case 'REGISTERED':
                        break;
                    case 'NOTIFICATION_LIST':
                        setNotificationList(JSON.parse(message.notificationList));
                        let tempList =  JSON.parse(message.notificationList);
                        tempList.forEach(n => {
                            if((n.videoStatus=== 'READY' || n.videoStatus=== 'ERROR') && n.status === 'UNREAD'){
                                setNotificationListVisible(true)
                            }
                        })
                        break;
                    case 'NOTIFICATION_UPDATE':
                        let notifications = notificationList;
                        let found = false;
                        notifications.forEach((n) => {
                            if (n.entityUuid === message.entityUuid) {
                                n.videoStatus = message.videoStatus;
                                n.videoPetraId = message.videoPetraId;
                                n.videoHeight = message.videoHeight;
                                n.videoWidth = message.videoWidth;
                                found = true;
                            }
                            if((message.videoStatus === 'READY' || message.videoStatus === 'ERROR') && message.status === 'UNREAD'){
                                setNotificationListVisible(true)
                            }
                        });
                        if (!found) {
                            notifications.unshift({
                                cardNo: message.cardNo,
                                videoStatus: message.videoStatus,
                                entityUuid: message.entityUuid,
                                status: message.status,
                                trxDate: message.trxDate,
                                type: message.type,
                            });
                        }
                        setNotificationList(notifications);
                        break;
                    case 'NOTIFICATION_REMOVED':
                        let afterRemove = notificationList;
                        afterRemove.forEach(function (item, index, object) {
                            if (message.entityUuid === item.entityUuid) {
                                object.splice(index, 1);
                            }
                        });
                        setNotificationList(afterRemove);
                        if (afterRemove.length === 0) {
                            setNotificationListVisible(false);
                        }
                        break;
                    case 'NOTIFICATION_MARKED_AS_READ':
                        let afterMarked = notificationList;
                        afterMarked.forEach((n) => {
                            if (message.entityUuid === n.entityUuid) {
                                n.status = 'READ';
                            }
                        });
                        setNotificationList(afterMarked);
                        if (afterMarked.length === 0) {
                            setNotificationListVisible(false);
                        }
                        break;
                    default:
                        console.log('Powiadomienia niedostępne, prosimy spróbować później');
                }
            } else {
            }
        },
        [notificationList]
    );

    useEffect(() => {
        if (props.websocket) {
            props.websocket.send(
                JSON.stringify({
                    operation: 'GET_NOTIFICATION_LIST',
                    token: props.token,
                })
            );
        }
    }, [props.token, props.websocket]);

    useEffect(() => {
        if (!props.websocket) return;
        props.websocket.onmessage = (m) => {
            updateNotificationList(m);
        };
    }, [updateNotificationList, props.websocket]);
    return (
        <div className='notification-list'>
            {transactionVideo && videoDialogVisible ? (
                <CustomDialog
                    id={`video-dialog-${transactionVideo?.petraId}`}
                    name='video-dialog'
                    element={transactionVideo}
                    onHide={(e) => {
                        setTvCardNo(undefined);
                        setTvDate(undefined);
                        setVideoDialogVisible(false)}}
                    visible={videoDialogVisible}
                    viewMode={'VIEW'}
                    className='transaction-video-dialog'
                    afterSave={(e) => setVideoDialogVisible(false)}
                    blockUi={props.blockUi}
                    unblockUi={props.unblockUi}
                    showMessage={props.showMessage}
                    header={t('transaction.videoDialogHeader', { videoDate: moment(tvDate).format('DD-MM-YYYY'), videoCardNo: tvCardNo })}
                >
                    {returnHlsPlayer()}
                </CustomDialog>
            ) : null}
            <div key='notification-icon' className='notification-icon'
                onClick={() => {
                    markAsReadNotifications();
                    setNotificationListVisible(!notificationListVisible);
                }}>
                {notificationList?.filter(n => n.status !== 'READ')?.length > 0 ? (
                    <div key='notification-icon-counter' className='notification-counter'>
                        {notificationList.filter(n => n.status !== 'READ')?.length}
                    </div>
                ) : null}
                <svg
                    version='1.0'
                    xmlns='http://www.w3.org/2000/svg'
                    width='24.000000pt'
                    height='24.000000pt'
                    viewBox='0 0 1920.000000 1920.000000'
                    preserveAspectRatio='xMidYMid meet'
                >
                    <g transform='translate(0.000000,1920.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>
                        <path
                            d='M9015 15889 c-168 -24 -412 -127 -550 -231 -243 -184 -407 -443 -472
-749 -25 -117 -25 -362 0 -479 40 -185 116 -355 224 -498 62 -83 69 -102 34
-102 -35 0 -319 -83 -461 -135 -573 -209 -1070 -522 -1509 -953 -424 -417
-758 -931 -969 -1492 -91 -242 -151 -466 -201 -740 -55 -304 -53 -262 -62
-1770 -4 -773 -10 -1425 -14 -1450 -3 -25 -13 -103 -21 -175 -65 -557 -247
-1105 -532 -1603 -104 -181 -178 -291 -311 -465 -194 -252 -207 -279 -199
-418 8 -138 86 -251 216 -312 l67 -32 1719 -5 1719 -5 18 -82 c62 -286 198
-533 413 -749 137 -136 260 -224 426 -303 182 -86 324 -124 531 -140 350 -28
676 58 979 260 127 84 315 272 399 399 115 173 187 339 229 530 l18 85 1720 5
1719 5 65 31 c130 62 210 177 218 313 8 139 -5 167 -199 418 -434 563 -718
1231 -829 1947 -42 271 -43 302 -50 1741 -7 1496 -5 1446 -61 1780 -76 453
-260 954 -506 1375 -431 738 -1119 1352 -1898 1695 -235 103 -579 219 -718
242 -20 3 -40 9 -42 14 -3 4 17 38 45 74 187 247 271 515 257 815 -15 311
-141 594 -362 813 -101 100 -186 160 -320 227 -130 64 -247 102 -369 119 -89
13 -274 12 -361 0z m306 -757 c288 -75 439 -402 309 -667 -149 -304 -554 -364
-781 -117 -174 190 -168 476 13 655 132 130 287 173 459 129z m194 -1955 c11
-3 47 -8 80 -11 1031 -117 1961 -713 2511 -1611 199 -326 353 -718 428 -1095
62 -309 59 -239 66 -1770 7 -1485 7 -1466 56 -1805 84 -586 310 -1235 607
-1745 30 -52 53 -98 51 -101 -4 -6 -8234 -9 -8234 -3 0 2 30 57 66 121 336
592 538 1218 626 1943 20 168 22 232 28 1585 7 1356 8 1415 28 1550 54 369
135 649 281 975 98 218 268 492 437 705 113 142 388 417 529 529 215 171 478
334 698 433 394 178 756 269 1212 307 59 5 501 -1 530 -7z m415 -8911 c0 -27
-81 -173 -131 -234 -101 -125 -270 -230 -429 -268 -96 -22 -251 -22 -345 1
-155 37 -324 144 -425 268 -47 57 -130 208 -130 235 0 9 177 12 730 12 624 0
730 -2 730 -14z'
                        />
                    </g>
                </svg>
            </div>
            {notificationList.length > 0 ? (
                <div key='notification-list-content' className={`notification-list-content ${notificationListVisible ? '' : 'hidden'}`}>
                    <div className='notification-list-content-triangle'>
                        <div className='notification-list-content-triangle-inner' />
                    </div>
                    <div
                        key='notification-list-scrollable-content'
                        className={`notification-list-scrollable-content ${notificationListVisible ? '' : 'hidden'}`}
                    >
                        {notificationList.map((n, i) => {
                            if (notificationList[i].type === 'VIDEO_PROCESS') {
                                return (
                                    <div
                                        key={`notification-item-${notificationList[i].entityUuid}`}
                                        className='notification-list-item'
                                        onClick={() => showVideoDialog(notificationList[i])}
                                    >
                                        <span
                                            key={`notification-item-title-${notificationList[i].entityUuid}`}
                                            className={`notification-list-item-title ${notificationList[i].videoStatus === 'ERROR' ? 'error' : ''
                                                }`}
                                        >
                                            {translate(`header.notification.title.video.${notificationList[i].videoStatus}`)}
                                        </span>
                                        <span
                                            key={`notification-item-content-${notificationList[i].entityUuid}`}
                                            className='notification-list-item-content'
                                        >
                                            {translate(`header.notification.content.video.${notificationList[i].videoStatus}`, {
                                                cardNo: notificationList[i].cardNo ? notificationList[i].cardNo : '-',
                                                date: notificationList[i].trxDate
                                                    ? moment(notificationList[i].trxDate).format('DD-MM-YYYY')
                                                    : '-',
                                            })}
                                            {notificationList[i].videoStatus === 'ERROR' ?
                                                <a className='email-link'
                                                    href='mailto:kontakt@moyastacja.pl'> kontakt@moyastacja.pl</a>
                                                : null}
                                        </span>

                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                    <ActionLink
                        label={`${translate('header.notification.clear')}`}
                        handleClick={() => {
                            clearNotifications();
                        }}
                        variant='blue'
                        className='edit-blue-link under-table-button-left-icon notification-clear-button'
                        key={'notification-clear-button'}
                    />
                </div>
            ) : null}
        </div>
    );
}
